import { VA_FORM_IDS } from '@department-of-veterans-affairs/platform-forms/constants';
import { getTrackingDefaults, trackAction } from './datadogRumTracking';

// ──────────────────────────────────────────────
// Entry gate outcome tracking
// ──────────────────────────────────────────────
// `isBdd` is passed in because each app version computes BDD from its own
// form data model.

const trackEntryGate = (
  actionName,
  properties,
  { formId = VA_FORM_IDS.FORM_21_526EZ, isBdd = false } = {},
) => {
  const { sourcePath } = getTrackingDefaults();
  trackAction(actionName, { formId, ...properties, sourcePath, isBdd });
};

export const trackMissingServices = options =>
  trackEntryGate(
    '21-526EZ_blocked_missing_services',
    { errorKey: 'missing_526_or_original_claims_service' },
    options,
  );

export const trackMissingId = options =>
  trackEntryGate(
    '21-526EZ_blocked_missing_id',
    { errorKey: 'missing_edipi_or_birls_id' },
    options,
  );

export const trackMissingDob = options =>
  trackEntryGate(
    '21-526EZ_blocked_missing_dob',
    { errorKey: 'missing_dob' },
    options,
  );

export const trackMissing526Identifiers = (
  missingIdentifierKeys = [],
  options,
) =>
  trackEntryGate(
    '21-526EZ_blocked_missing_526_identifiers',
    { errorKey: 'missing_526_identifiers', missingIdentifierKeys },
    options,
  );

export const trackPassedEntryGate = options =>
  trackEntryGate('21-526EZ_passed_entry_gate', {}, options);
